import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ConfiguracaoCategoriaFinanceiraPadraoRequest } from '../../requests/financas/configuracao-categoria-financeira-padrao.request';
import { ConfiguracaoCategoriaFinanceiraPadraoResponse } from '../../responses/financas/configuracao-categoria-financeira-padrao.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class ConfiguracaoCategoriaFinanceiraPadraoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'ConfiguracaoCategoriaFinanceiraPadrao';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(): Observable<ConfiguracaoCategoriaFinanceiraPadraoResponse> {
        return this.httpClient
            .get<ConfiguracaoCategoriaFinanceiraPadraoResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError.bind(this)));
    }

    public update(request: ConfiguracaoCategoriaFinanceiraPadraoRequest): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError.bind(this)));
    }
}
